module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/mvideo.46196886.svg";